'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cookieMonster = require('cookie');

/**
 * @ignore
 * Created by daletan on 9/13/16.
 */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var undefined = void 0;

var keys = Object.freeze({
    USER: 'userToken', // <id>_<hash>
    SELLER: 'sellerToken', // <VERTICAL PREFIX>_<id>_<hash>
    MASQUERADE_BUYER: 'masqueradeBuyer', // U_<id>
    MASQUERADE_SELLER: 'masqueradeSeller', // S_<id>_<VERTICAL PREFIX>
    USER_TYPE: 'userType',
    GUEST_ID: 'guestId',
    EVER_LOGGED_IN: 'eli',
    PASSWORD_RESET: 'passwordToken'
});

/**
 * @param {string} value
 * @returns {object|null}
 */
var getMasqueradeValues = function getMasqueradeValues() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!value) {
        return null;
    }

    var _value$split = value.split('_');

    var _value$split2 = _slicedToArray(_value$split, 3);

    var type = _value$split2[0];
    var id = _value$split2[1];
    var vertical = _value$split2[2];

    var parts = {
        type: type,
        id: id
    };
    if (vertical) {
        parts.vertical = vertical;
    }
    return parts;
};

/**
 * @param {string|object} cookie
 * @param {string} cookieKey
 * @returns {string|undefined}
 */
var getCookieValue = function getCookieValue(cookie, cookieKey) {
    var parsed = typeof cookie === 'string' ? cookieMonster.parse(cookie) : cookie;
    return parsed && parsed[cookieKey] || undefined;
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeSellerInfo = function getMasqueradeSellerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_SELLER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeBuyerInfo = function getMasqueradeBuyerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_BUYER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeSellerId = function getMasqueradeSellerId(cookie) {
    var parts = getMasqueradeSellerInfo(cookie);
    return parts ? parts.vertical.toLowerCase() + '_' + parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeBuyerId = function getMasqueradeBuyerId(cookie) {
    var parts = getMasqueradeBuyerInfo(cookie);
    return parts ? parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getUserTokenString = function getUserTokenString(cookie) {
    return getCookieValue(cookie, keys.USER);
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getSellerTokenString = function getSellerTokenString(cookie) {
    return getCookieValue(cookie, keys.SELLER);
};

/**
 * @param {*} token seller token
 * @returns {boolean}
 */
var isSellerToken = function isSellerToken(token) {
    return (/^[fjva]_/i.test(token)
    );
};

/**
 * @param {*} token user token
 * @returns {boolean}
 */
var isBuyerToken = function isBuyerToken(token) {
    return (/^\d+_/i.test(token)
    );
};

/**
 *
 * @param {string} token user or seller token
 * @returns {string|null}
 */
var splitToken = function splitToken() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var parts = token.split('_');
    // an empty string will still return an array length of 1
    if (parts[0] !== '') {
        if (isSellerToken(token)) {
            return parts[0] + '_' + parts[1];
        } else if (isBuyerToken(token)) {
            // need this check otherwise an invalid
            // seller token will be used
            return parts[0];
        }
    }
    return null;
};

/**
 * based off of bunsen/libraries/bunsen#getMasqueradeAsUserId
 * The bunsen version returned an `object.userId`
 * This version only returns a string or null
 * @param {string|object} cookie
 * @param {string} type
 * @returns {string|null}
 */
var getMasqueradeUserIdByType = function getMasqueradeUserIdByType(cookie, type) {
    if (type === keys.MASQUERADE_SELLER) {
        return getMasqueradeSellerId(cookie);
    } else if (type === keys.MASQUERADE_BUYER) {
        return getMasqueradeBuyerId(cookie);
    }
    return null;
};

/**
 * @param {string} cookie
 * @param {string} [userType] The type of user masquerade info to return
 * @returns {string|null}
 */
var getMasqueradeValue = function getMasqueradeValue(cookie, userType) {
    var parsed = cookieMonster.parse(cookie);
    return getMasqueradeUserIdByType(parsed, userType) || null;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var cookieJarConstants = keys;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getPasswordReset(cookie) {
    return getCookieValue(cookie, keys.PASSWORD_RESET);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getUserType(cookie) {
    return getCookieValue(cookie, keys.USER_TYPE);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getGuestId(cookie) {
    return getCookieValue(cookie, keys.GUEST_ID);
}

/**
 * backwards compatibility
 * public api method will be removed in next major release, use {@link getBuyerToken}
 * @deprecated
 * @param {string} cookie
 */
var getUserToken = getUserTokenString;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getEverLoggedIn(cookie) {
    return getCookieValue(cookie, keys.EVER_LOGGED_IN);
}

/**
 * based off of bunsen/models/identity/User#getUserId
 * The additional change here is adding the `userType` as the bunsen
 * version only assumed the buyer. The seller is also taken into account
 * @param {string} cookie document.cookie or req.cookie string
 * @param {string} [userType] The type of user masquerade info to return
 * @param {boolean} [getRealUser] returns the actual user (usually internal) if you happen to be masquerading
 * @returns {string|null}
 */
function getUserId(cookie, userType, getRealUser) {

    if (typeof cookie !== 'string') {
        throw new Error('a cookie string must be passed in. a ' + (typeof cookie === 'undefined' ? 'undefined' : _typeof(cookie)) + ' was passed passed in instead.');
    }

    var masqueradeInfo = getMasqueradeValue(cookie, userType);

    if (masqueradeInfo && !getRealUser) {
        return masqueradeInfo;
    }

    var userId = splitToken(getUserTokenString(cookie));
    return userId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {string|null}
 */
function getSellerId(cookie) {
    var sellerId = splitToken(getSellerTokenString(cookie));
    return sellerId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {function}
 */
function isMasqueradingByType(cookie) {
    var userId = getUserId(cookie, null, true);
    /**
     * @param {string} userType
     * @returns {boolean}
     */
    return function (userType) {
        // return `false` instead of `null`
        return (userId ? userId : false) && !!getMasqueradeUserIdByType(cookie, userType);
    };
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsSeller(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_SELLER);
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsBuyer(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_BUYER);
}

/**
 * based off of bunsen/helpers/actingUser#isMasquerading
 * The bunsen version would pull the buyer user info from server vars
 * There should be a `userToken` cookie value set for the internal
 * user if you are masquerading
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasquerading(cookie) {
    var sellerId = isMasqueradingAsSeller(cookie);
    var buyerId = isMasqueradingAsBuyer(cookie);
    return !!(sellerId || buyerId);
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * @param {string} cookie
 * @returns {object}
 */
function getBuyerToken(cookie) {
    var userToken = getUserTokenString(cookie);
    if (userToken) {
        return {
            userToken: userToken
        };
    }
    return {};
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * sellerToken takes precedence over userToken (userToken case should
 * only be hit while masquerading)
 * @param {string} cookie
 * @returns {object}
 */
function getAdminToken(cookie) {
    // if seller token, return seller token
    var sellerToken = getSellerTokenString(cookie);
    if (sellerToken) {
        return {
            sellerToken: sellerToken
        };
    }

    // either a logged in admin user or masquerading as a seller
    // leveraging `getBuyerToken` logic
    // returns an object already
    // and will also return an empty object
    // for a falsey value
    return getBuyerToken(cookie);
}

exports.cookieJarConstants = cookieJarConstants;
exports.getPasswordReset = getPasswordReset;
exports.getUserType = getUserType;
exports.getGuestId = getGuestId;
exports.getUserToken = getUserToken;
exports.getEverLoggedIn = getEverLoggedIn;
exports.getUserId = getUserId;
exports.getSellerId = getSellerId;
exports.isMasqueradingByType = isMasqueradingByType;
exports.isMasqueradingAsSeller = isMasqueradingAsSeller;
exports.isMasqueradingAsBuyer = isMasqueradingAsBuyer;
exports.isMasquerading = isMasquerading;
exports.getBuyerToken = getBuyerToken;
exports.getAdminToken = getAdminToken;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-cookie-jar/dist/index.js
// module id = 322
// module chunks = 63